import { render, staticRenderFns } from "./hiTagger.vue?vue&type=template&id=2cd7c014&"
import script from "./hiTagger.vue?vue&type=script&lang=js&"
export * from "./hiTagger.vue?vue&type=script&lang=js&"
import style0 from "./hiTagger.vue?vue&type=style&index=0&id=2cd7c014&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports